import { Box, List, ListItem, Typography } from '@mui/material';

// GH-792 (Karen, 12.10.2026) — top of the "יומן פגישות ומפגשים פרטניים" tab in both info pages (experts +
// therapists): the reminders now carry a GroupHug join link instead of the expert's Zoom link (GH-753), so
// arrival is tracked and no-shows can be handled. The T-15 reminder (email + WhatsApp) is live since 12.10.
const ZoomLinkNotice = () => (
	<Box
		sx={{
			border: '1px solid',
			borderColor: 'primary.light',
			backgroundColor: 'grey.50',
			p: 1.5,
			borderRadius: 1,
			mb: 1.5,
			direction: 'rtl',
			textAlign: 'right',
		}}
	>
		<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
			כניסה לפגישות אישיות דרך הקישור של GroupHug
		</Typography>
		<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
			כדי לשפר את המעקב אחר הפגישות האישיות ולאפשר טיפול מהיר במקרים של אי-הגעה, הכניסה לפגישות מתבצעת מעכשיו
			דרך קישור ייעודי של GroupHug.
		</Typography>

		<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
			איך זה עובד?
		</Typography>
		<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
			בתזכורות לפגישה שנשלחות אליכם במייל ובוואטסאפ יופיע קישור של GroupHug במקום קישור הזום הישיר שלכם.
			<br />
			לחיצה על הקישור תעביר אתכם ישירות לפגישת הזום כרגיל, ללא שינוי באופן ניהול הפגישה.
		</Typography>

		<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
			למה חשוב להיכנס דרך הקישור?
		</Typography>
		<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
			הכניסה דרך הקישור מאפשרת למערכת לזהות שהגעתם לפגישה. כך, במקרה של אי-הגעה מצד העובד, נוכל לזהות זאת בזמן
			אמת ולסייע בטיפול במקרה.
		</Typography>

		<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
			מה חשוב לזכור?
		</Typography>
		<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
			<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
				<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
					• יש להיכנס לכל פגישה אישית דרך הקישור שמופיע בתזכורת, ולא ישירות דרך אפליקציית Zoom.
				</Typography>
			</ListItem>
			<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
				<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
					• יש לוודא שקישור הזום האישי שלכם באזור המומחים מעודכן ותקין.
				</Typography>
			</ListItem>
			<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
				<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
					• בנוסף, 15 דקות לפני כל פגישה נשלחת אליכם תזכורת במייל ובוואטסאפ עם קישור הכניסה.
				</Typography>
			</ListItem>
		</List>

		<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
			<b>שימו לב:</b> הקישור החדש אינו משנה את אופן קיום הפגישה, אלא מאפשר לנו לעקוב אחר ההגעה ולתת לכם מענה מהיר
			ומדויק יותר בעת הצורך.
		</Typography>
	</Box>
);

export default ZoomLinkNotice;
